waitForAppstleWidget((widget) => {
  updateWidgetCustomContent();
  setTimeout(() => {
    document
      .querySelectorAll(".appstle_sub_widget input[name=selling_plan]")
      .forEach((radio) => {
        radio.addEventListener("change", (e) => {
          const variant = variantRadios.currentVariant;
          if (variant) {
            updatePerServingPrices(variant);
          }
        });
      });
  }, 1000);
});

function updateWidgetCustomContent() {
  /* To add custom elements to subscription widget */

  const targetElements = document.querySelectorAll(
    ".template-adaptolatte-redesign .appstle_subscribe_option"
  );
  const subscriptionDiv = document.querySelector(".subscription_custom_info");
  const subscriptionImage = document.querySelector(
    ".subscription_image img"
  )?.outerHTML;

  const subscriptionContainers = document.querySelectorAll(
    ".template-adaptolatte-redesign .appstle_subscription_wrapper_option.appstle_include_dropdown"
  );
  const subscriptionSaverText = document.querySelector(
    ".subscription_saver_text"
  );

  if (document.querySelector(".appstle_sub_widget .subscription_custom_info"))
    return;

  // Insert subscription_custom_info after each .appstle_subscribe_option
  if (subscriptionDiv && targetElements.length > 0) {
    targetElements.forEach((targetElement) => {
      const subscriptionInfoDiv = document.createElement("div");
      subscriptionInfoDiv.classList.add("subscription_custom_info");
      subscriptionInfoDiv.innerHTML = subscriptionImage
        ? subscriptionDiv.innerHTML + subscriptionImage
        : subscriptionDiv.innerHTML;

      targetElement.parentNode.insertBefore(
        subscriptionInfoDiv,
        targetElement.nextSibling
      );
    });
  }

  // Prepend promo banner to each .sls-option-container
  if (subscriptionSaverText && subscriptionContainers.length > 0) {
    subscriptionContainers.forEach((container) => {
      const newDiv = document.createElement("div");
      newDiv.textContent = subscriptionSaverText.innerHTML;
      newDiv.className = "subscription_promo_banner";
      container.prepend(newDiv);
    });
  }
}

const variantRadios = document.querySelector("variant-radios");

if (variantRadios) {
  variantRadios.addEventListener("change", () => {
    updateWidgetCustomContent();
    const variant = variantRadios.currentVariant;
    if (variant) {
      updatePerServingPrices(variant);
            setTimeout(function() {
                    document.querySelectorAll(".appstle_sub_widget input[name='selling_plan']")
        .forEach(r => {
          r.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }, 800);
    }
  });

  // window.addEventListener("DOMContentLoaded", () => {
  //   variantRadios.dispatchEvent(new Event("change", { bubbles: true }));
  // });
}

const addToCartBtn = document.querySelectorAll(".js-add-upsell-product");
if (addToCartBtn.length > 0) {
  addToCartBtn.forEach((button) => {
    button.addEventListener("click", async (e) => {
      const variantId = parseInt(button.getAttribute("data-variant-id"));
      const sellingPlanId = parseInt(button.getAttribute("data-selling-plan"));

      try {
        const addToCartResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [
              { id: variantId, quantity: 1, selling_plan: sellingPlanId },
            ],
          }),
        });

        if (!addToCartResponse.ok) throw new Error("Add to cart failed");

        const sectionsResponse = await fetch(
          "/?sections=cart-drawer,cart-icon-bubble"
        );
        const sectionData = await sectionsResponse.json();

        const cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.renderContents({
          id: variantId,
          sections: sectionData,
        });
        cartDrawer.classList.remove("is-empty");
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    });
  });
}

// function updatePerServingPrices(currentVariant) {
//   // console.log(currentVariant);
//   const flavourOption = currentVariant.option3;
//   const packing = currentVariant.option1;
//   const variantSelectList = document.querySelectorAll(
//     ".js-variant-list-prices select option"
//   );
//   const quantityOptions = document.querySelectorAll(
//     ".product-form__input.option--3 label"
//   );
//   const purchaseTypeField = document.querySelector(
//     ".template-adaptolatte-redesign .appstle-active-option input[type='radio']:checked"
//   );

//   const purchaseType =
//     purchaseTypeField?.value.length == 0 ? "onetime" : "subscription";

//   if (variantSelectList.length > 0) {
//     variantSelectList.forEach((option) => {

//       if (
//         option.innerText.includes(flavourOption) &&
//         option.innerText.includes(packing)
//       ) {
//         // console.log(option);
//         if (option.innerText.includes("30")) {
//           quantityOptions[0].querySelector(
//             ".option__priceSavingValue"
//           ).innerText =
//             purchaseType == "subscription"
//               ? option.dataset.subcPrice
//               : option.dataset.onetimePrice;
//         } else if (option.innerText.includes("60")) {
//           quantityOptions[1].querySelector(
//             ".option__priceSavingValue"
//           ).innerText =
//             purchaseType == "subscription"
//               ? option.dataset.subcPrice
//               : option.dataset.onetimePrice;
//         } else if (option.innerText.includes("90")) {
//           quantityOptions[2].querySelector(
//             ".option__priceSavingValue"
//           ).innerText =
//             purchaseType == "subscription"
//               ? option.dataset.subcPrice
//               : option.dataset.onetimePrice;
//         }
//       }
//     });
//   }
// }

function waitForAppstleWidget(callback, timeout = 10000) {
  const start = Date.now();
  const interval = setInterval(() => {
    const widget = document.querySelector(".appstle_sub_widget");
    if (widget) {
      clearInterval(interval);
      callback(widget);
    } else if (Date.now() - start > timeout) {
      clearInterval(interval);
      console.warn("Appstle widget not found within timeout");
    }
  }, 100);
}


//--------------update per serving price--------------//

// function updatePerServingPrices() {
//   const priceEl = document.querySelector(".appstle_subscription_final_price");
//   const servingBlocks = document.querySelectorAll(".js-price-serving");

//   if (!priceEl || servingBlocks.length === 0) return;

//   // Get numeric value from price text
//   const rawText = priceEl.innerText.trim();
//   const numMatch = rawText.replace(",", ".").match(/\d+(\.\d+)?/);

//   if (!numMatch) return;

//   const subPrice = parseFloat(numMatch[0]);
//   if (isNaN(subPrice) || subPrice <= 0) return;

//   servingBlocks.forEach((block) => {
//     let servings = parseInt(block.dataset.serving || block.innerText.match(/\d+/), 10);
//     if (!servings) return;

//     // Calculate per serving
//     const perCup = (subPrice / servings);
    
//     // Ensure two decimal places, always rounding down
//     const perCupFixed = Math.floor(perCup * 100) / 100;

//     const newDisplay = rawText.replace(/\d+(\.\d+)?/, perCupFixed.toFixed(2));

//     const target = block.querySelector(".option__priceSavingValue") || block;
//     target.innerText = newDisplay;
//   });
// }

// document.addEventListener("DOMContentLoaded", () => {
//   let tries = 0;
//   const interval = setInterval(() => {
//     updatePerServingPrices();
//     tries++;
//     if (tries > 20) clearInterval(interval); 
//   }, 300);
// });

function updatePerServingPrices() {
  const selectedOption = document.querySelector('input[name="selling_plan"]:checked');
  if (!selectedOption) return;

  const subWrapper = selectedOption.closest(".appstle_subscription_wrapper_option");
  const priceEl = subWrapper?.querySelector(".appstle_subscription_amount") || subWrapper?.querySelector(".appstle_one_time_price_wrapper .appstle_subscription_amount");
  if (!priceEl) return;

  const priceText = priceEl.innerText.trim();
  const subPrice = parseLocalizedPrice(priceText);
  if (isNaN(subPrice) || subPrice <= 0) return;

  const servingBlocks = document.querySelectorAll(".js-price-serving");

  // Find which cup count is selected in the number of cups radios
  const selectedCupInput = document.querySelector('input[name="Number of cups"]:checked');
  const selectedCupValue = selectedCupInput ? parseInt(selectedCupInput.value, 10) : null;

  servingBlocks.forEach((block) => {
    const servings = parseInt(block.dataset.serving || block.innerText.match(/\d+/), 10);
    if (!servings) return;

    // Show price only if this block's servings is the selected one
    if (servings === selectedCupValue) {
      const perCup = Math.floor((subPrice / servings) * 100) / 100;
      const formatted = perCup.toFixed(2);
      const newDisplay = priceText.replace(/\d+([.,]\d+)?/, formatted);
      const target = block.querySelector(".option__priceSavingValue") || block;
      target.innerText = newDisplay;
      block.style.display = ''; // make sure it's visible
    } else {
      // Hide or clear price for other serving blocks
      const target = block.querySelector(".option__priceSavingValue") || block;
      target.innerText = '';
      // or if you want to hide the whole block:
      // block.style.display = 'none';
    }
  });
}



document.addEventListener("DOMContentLoaded", () => {
  //  Listen to change on "Subscribe" or "One-time purchase"
  document.querySelectorAll('input[name="selling_plan"]').forEach((input) => {
    input.addEventListener("change", () => {
      setTimeout(updatePerServingPrices, 100);
    });
  });

  //  Listen to change on "Number of cups" radios (30 / 60 / 90 cups)
  document.querySelectorAll('input[name="Number of cups"]').forEach((input) => {
    input.addEventListener("change", () => {
      setTimeout(updatePerServingPrices, 100);
    });
  });

  //  Optional: fallback polling to catch unexpected changes
  let lastPlan = null;
  let lastCups = null;
  setInterval(() => {
    const selectedPlan = document.querySelector('input[name="selling_plan"]:checked');
    const selectedCups = document.querySelector('input[name="Number of cups"]:checked');

    const currentPlan = selectedPlan?.value || "";
    const currentCups = selectedCups?.value || "";

    if (currentPlan !== lastPlan || currentCups !== lastCups) {
      lastPlan = currentPlan;
      lastCups = currentCups;
      updatePerServingPrices();
    }
  }, 500);
});




function parseLocalizedPrice(priceString) {
  // Remove currency symbols and non-digit characters except comma or dot
  let clean = priceString.replace(/[^\d.,]/g, '');

  // If comma is decimal separator (e.g. "39,99"), replace with dot
  if (clean.includes(',') && clean.includes('.')) {
    // Likely format: 1.234,56 => remove thousand separator
    clean = clean.replace(/\./g, '').replace(',', '.');
  } else if (clean.includes(',')) {
    clean = clean.replace(',', '.');
  }

  return parseFloat(clean);
}

// /* Double subscription logic */
// const container = document.querySelector('.double-subscription-purchase_container');

// if (container) {
//   const nextButton = document.querySelector('.js-subscription-next-step');
//   const backButton = document.querySelector('.js-subscriptions-list-back-btn');
//   const addToCartBtn = document.querySelector('.product-form__submit');
//   const variantPickerContainer = document.querySelector('.variant_picker_redesigned');
//   const sellingItems = document.querySelectorAll('.js-selling-item');
//   const sellingItemsOptions = document.querySelectorAll('.selling-item.second-step-item');

//   // Default selection: Double subscription with "Original (Mocha) + Decaf (Cocoa)"
//   let purchaseValue = 'double-sub';
//   document.querySelector('.double-sub.js-option-container > div').click();
//   document.querySelector('.double-subscription-variants .product-form__input.option--3 input[value="Original (Mocha) + Decaf (Cocoa)"]').checked = true;
//   document.querySelector('.subscription-step-2 .double-sub > div:nth-child(2)').click(); // Select "Original (Mocha) + Decaf (Cocoa)"

//   // Variant radios change handler
//   const variantRadios = document.querySelector("variant-radios");
//   if (variantRadios) {
//     variantRadios.addEventListener("change", () => {
//       const variant = variantRadios.currentVariant;
//       if (variant && variant.option1) {
//         // Show/hide images based on packing type
//         document.querySelectorAll('.selling-item__images img').forEach(image => {
//           if (image.classList.contains(`image--${variant.option1}`)) {
//             image.classList.remove('hidden');
//           } else {
//             image.classList.add('hidden');
//           }
//         });

//         // Show/hide bullet points based on packing type
//         const typeMap = { 
//           'Pouch': 'pouch', 
//           'Travel Pack': 'travel-pack' 
//         };
//         const targetClass = typeMap[variant.option1] || '';
        
//         document.querySelectorAll('.selling-item__bullets').forEach(list => {
//           if (targetClass && list.classList.contains(targetClass)) {
//             list.classList.remove('hidden');
//           } else {
//             list.classList.add('hidden');
//           }
//         });
//       }
//     });
//   }

//   // Step 1: Selling items click (Choose subscription type)
//   sellingItems.forEach((item) => {
//     item.addEventListener("click", () => {
//       // Remove active class from all items
//       sellingItems.forEach((sellingItem) => sellingItem.classList.remove('active'));
      
//       // Add active class to clicked item
//       item.classList.add('active');

//       // Store selected plan type
//       purchaseValue = item.dataset.plan;

//       // Update Step 2 heading
//       document.querySelector('.subscription-step-2 h2').innerText =
//         item.querySelector('.selling-item__title').dataset.title;

//       // Hide all option containers
//       document.querySelectorAll('.subscription-step-2 .js-option-container').forEach((div) => {
//         div.classList.add('hidden');
//       });

//       // Show selected plan's options
//       const activePlanDiv = document.querySelector(`.subscription-step-2 .${purchaseValue}`);
//       activePlanDiv.classList.remove('hidden');

//       // Auto-select first flavor option in variant picker
//       const firstOptionFlavour = activePlanDiv.children[0].dataset.flavourOption;
//       const variantInput = document.querySelector(
//         `.double-subscription-variants .product-form__input.option--3 input[value="${firstOptionFlavour}"]`
//       );
      
//       if (variantInput) {
//         variantInput.checked = true;
//       }
      
//       // Trigger click on first option
//       activePlanDiv.querySelector('.selling-item.second-step-item').click();

//       // Trigger corresponding Seal Subscriptions selling plan
//       if (purchaseValue === 'one-time') {
//         // Select one-time purchase option
//         const oneTimeOption = document.querySelector('.sls-purchase-options-container')?.lastElementChild;
//         if (oneTimeOption) oneTimeOption.click();
//       } else if (purchaseValue === 'single-sub') {
//         // Select single subscription
//         const singleSubOption = document.querySelectorAll('.sls-option-container')[0];
//         if (singleSubOption) singleSubOption.click();
//       } else if (purchaseValue === 'double-sub') {
//         // Select double subscription
//         const doubleSubOption = document.querySelectorAll('.sls-option-container')[1];
//         if (doubleSubOption) doubleSubOption.click();
//       }
//     });
//   });

//   // Step 2: Selling item options click (Choose specific flavor combination)
//   sellingItemsOptions.forEach((item) => {
//     item.addEventListener("click", () => {
//       // Remove active class from all options
//       sellingItemsOptions.forEach((sellingItem) => sellingItem.classList.remove('active'));
      
//       // Add active class to clicked option
//       item.classList.add('active');

//       // Update variant picker radio button
//       const flavourOption = item.dataset.flavourOption;
//       const inputRadio = document.querySelector(
//         `.double-subscription-variants .product-form__input.option--3 input[value="${flavourOption}"]`
//       );

//       if (inputRadio) {
//         inputRadio.checked = true;
//         inputRadio.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     });
//   });

//   // Next button (Step 1 → Step 2)
//   nextButton.addEventListener("click", () => {
//     // Show Step 2 elements
//     [
//       addToCartBtn, 
//       variantPickerContainer, 
//       backButton, 
//       document.querySelector('.subscription-step-2')
//     ].forEach(el => {
//       if (el) el.classList.remove('hidden');
//     });
    
//     // Hide Step 1 elements
//     [
//       nextButton, 
//       document.querySelector('.subscription-step-1')
//     ].forEach(el => {
//       if (el) el.classList.add('hidden');
//     });
//   });

//   // Back button (Step 2 → Step 1)
//   backButton.addEventListener("click", () => {
//     // Hide Step 2 elements
//     [
//       addToCartBtn, 
//       variantPickerContainer, 
//       document.querySelector('.subscription-step-2'), 
//       backButton
//     ].forEach(el => {
//       if (el) el.classList.add('hidden');
//     });
    
//     // Show Step 1 elements
//     [
//       nextButton, 
//       document.querySelector('.subscription-step-1')
//     ].forEach(el => {
//       if (el) el.classList.remove('hidden');
//     });
//   });
// }



///////////////////////// Variant change pe price update karne ke liye script //////////////////////////////

// document.addEventListener("DOMContentLoaded", function () {
//   const variantSelectors = document.querySelectorAll(
//     'input[name="id"], select[name="id"]'
//   );

//   // Price display element
//   const priceElement = document.querySelector(".add-to-cart-price");
//   const compareAtPriceElement = document.querySelector(
//     ".add-to-cart-comparePrice"
//   );

//   // Product form
//   const productForm = document.querySelector('form[action="/cart/add"]');

//   if (!productForm || !priceElement) {
//     console.error("Required elements not found");
//     return;
//   }

//   // Get product data (Shopify theme usually stores this in a JSON script tag)
//   const productId = productForm.querySelector(
//     'input[name="product-id"]'
//   )?.value;

//   // Function to update price based on selected variant
//   function updatePrice(variantId) {
//     // Fetch variant data from Shopify API
//     fetch(`/products/${window.location.pathname.split("/").pop()}.js`)
//       .then((response) => response.json())
//       .then((product) => {
//         const selectedVariant = product.variants.find((v) => v.id == variantId);

//         if (selectedVariant) {
//           const price = (selectedVariant.price / 100).toFixed(2);
//           const comparePrice = selectedVariant.compare_at_price
//             ? (selectedVariant.compare_at_price / 100).toFixed(2)
//             : null;

//           // Price update
//           priceElement.textContent = `£${price}`;

//           if (comparePrice && comparePrice > price) {
//             compareAtPriceElement.textContent = `£${comparePrice}`;
//             compareAtPriceElement.style.display = "inline";
//           } else {
//             compareAtPriceElement.textContent = "";
//             compareAtPriceElement.style.display = "none";
//           }

//           // Button state update
//           const submitButton = document.getElementById(
//             "ProductSubmitButton-template--25464795889968__main"
//           );
//           if (submitButton) {
//             if (selectedVariant.available) {
//               submitButton.disabled = false;
//               submitButton.querySelector("span:first-child").textContent =
//                 "Add to cart";
//             } else {
//               submitButton.disabled = true;
//               submitButton.querySelector("span:first-child").textContent =
//                 "Sold out";
//             }
//           }
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching product data:", error);
//       });
//   }

//   variantSelectors.forEach((selector) => {
//     selector.addEventListener("change", function (e) {
//       const selectedVariantId = e.target.value;
//       updatePrice(selectedVariantId);
//     });
//   });

//   // Initial load set current variant price
//   const currentVariantId = document.querySelector(".product-variant-id")?.value;
//   if (currentVariantId) {
//     updatePrice(currentVariantId);
//   }
// });



























